module.exports = __webpack_public_path__ + "img/user.3c1dd009.png";